module.exports = __webpack_public_path__ + "img/nihr-logo.442a8157.svg";